









































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../../domain";
import { IWizardPage } from "../../../../../../domain/format";
import { User } from "../../../../../../domain/user";
import { Department } from "../../../../../../domain/department";
import { DialogMixin } from "../../../../../system/mixins";
import { EditingDocument } from "../../../EditingDocument";
import { IConfirmDialogOptions } from "../../../../../system";
import { IDepartmentDialogCondition } from "../../../../../department/dialogs";

interface ISetting {
  allowNoRequiredInputs: boolean;
  shouldSkipDisablePages: boolean;
}

@Component
export default class SettingDialog extends Mixins(DialogMixin) {
  @Prop()
  document: EditingDocument;

  @Prop()
  pages: IWizardPage[];

  @Prop()
  isRegistered: boolean;

  data(): any {
    return {
      lastSetting: {},
      setting: {},
    };
  }
  lastSetting: ISetting;
  setting: ISetting;

  get shouldApply(): boolean {
    return (this.setting.allowNoRequiredInputs !== this.lastSetting.allowNoRequiredInputs)
        || (this.setting.shouldSkipDisablePages !== this.lastSetting.shouldSkipDisablePages);
  }

  get user(): User {
    return this.$store.getters.user;
  }

  get userName(): string {
    return this.user
      ? this.user.name
      : "";
  }

  get department(): Department {
    return this.$store.getters.department;
  }

  get departmentName(): string {
    return this.department
      ? this.department.name
      : "";
  }

  async logout(): Promise<void> {
    try {
      if (await this.confirmLogout()) {
        await DomainRegistry.authentication.getAuthenticationService().logout();
        this.$redirectEntryRoute();
      }
    } catch (e) {
      this.$error("ログアウト失敗", "ログアウトできませんでした。");
    }
  }

  private async confirmLogout(): Promise<boolean> {
    return (await this.$commonDialogs.confirmation.show(this.logoutConfirmationOptions) === 1);
  }

  get logoutConfirmationOptions(): IConfirmDialogOptions {
    return this.isRegistered
      ? {
        message: [
          "ログアウトします。",
          "よろしいですか？",
        ],
        buttons: [
          {
            kind: "cancel",
            label: "ログアウトしない",
          },
          {
            kind: "confirm",
            label: "ログアウトする",
          },
        ],
      }
      : {
        message: [
          "現在入力中の内容は破棄されます。",
          "本当によろしいですか？",
        ],
        buttons: [
          {
            kind: "cancel",
            label: "ログアウトしない",
          },
          {
            kind: "danger",
            label: "破棄してログアウトする",
          },
        ],
      };
  }

  get patientSwitchButtonLabel(): string {
    return this.isRegistered ? "患者変更" : "入力中止";
  }

  async switchPatient(): Promise<void> {
    try {
      if (await this.confirmPatientSwitch()) {
        this.$redirectEntryRoute(p => p.replace(/patientNo=[^&]+(&|)/, "").replace(/(\?|&)$/, ""));
      }
    } catch (e) {
      this.$error("患者変更失敗", "患者変更できませんでした。");
    }
  }

  private async confirmPatientSwitch(): Promise<boolean> {
    return (await this.$commonDialogs.confirmation.show(this.patientSwitchConfirmationOptions) === 1);
  }

  get patientSwitchConfirmationOptions(): IConfirmDialogOptions {
    return this.isRegistered
      ? {
        message: [
          "患者を変更します。",
          "よろしいですか？",
        ],
        buttons: [
          {
            kind: "cancel",
            label: "変更しない",
          },
          {
            kind: "confirm",
            label: "変更する",
          },
        ],
      }
      : {
        message: [
          "現在入力中の内容は破棄されます。",
          "本当によろしいですか？",
        ],
        buttons: [
          {
            kind: "cancel",
            label: "中止しない",
          },
          {
            kind: "danger",
            label: "破棄して中止する",
          },
        ],
      };
  }

  get patientNo(): string {
    return this.document.attributes.patient.id;
  }

  get patientName(): string {
    return this.document.attributes.patient.name;
  }

  get formatName(): string {
    return this.document.attributes.format.name;
  }

  get documentDepartment(): Department {
    return this.document.attributes.department;
  }

  set documentDepartment(source: Department) {
    this.document.attributes.department = source;
  }

  get documentDepartmentName(): string {
    return this.documentDepartment
      ? this.documentDepartment.name
      : "";
  }

  get pageCount(): number {
    return this.pages.length;
  }

  get isPageNavigatable(): boolean {
    return (1 < this.pageCount);
  }

  get pageNavigationInputClass(): string {
    return this.isPageNavigatable
      ? ""
      : "disabled";
  }

  async selectDocumentDepartment(): Promise<void> {
    const condition = {
      name: this.$wording.common.department + "属性",
    };
    const department = await this.showDepartmentButtonSelectorDialog(condition, this.documentDepartment);
    if (department) {
      this.documentDepartment = department;
    }
  }

  async showDepartmentButtonSelectorDialog(condition: IDepartmentDialogCondition, defaultOption?: Department): Promise<Department> {
    const department = await this.$commonDialogs.department.buttonSelector.selectOptionConditionally(condition, defaultOption);
    return department;
  }

  async show(setting: ISetting): Promise<ISetting> {
    await this.showModal(async () => {
      this.lastSetting = {
        allowNoRequiredInputs: setting.allowNoRequiredInputs,
        shouldSkipDisablePages: setting.shouldSkipDisablePages,
      };
      this.setting = {
        allowNoRequiredInputs: setting.allowNoRequiredInputs,
        shouldSkipDisablePages: setting.shouldSkipDisablePages,
      };
      await this.waitHidden();
    });
    return this.shouldApply ? this.setting : null;
  }

  close(): void {
    this.isVisible = false;
  }
}
